export default "__VITE_ASSET__DzLcSd5J__"